import React from "react"
import VacationDayVariantChip from "../../../components/molecules/VacationDayVariantChip.molecule"
import {
    VACATION_DAY_TYPES,
    HOLIDAY_TYPES_IDS,
    VACATION_APPROVED_STATUS,
} from "../../../consts/modules/vacations.consts"

const PendingRequestsColumn = ({
    data,
    overlayRef,
    setOverlayRequests,
    setActiveTeamMember,
    setSelectedVacationRequest,
    setVisibleRequestModal,
    cmRef,
}) => {
    const requestsList = data.pendingRequestsList || []

    const pendingApproval = requestsList.filter(
    r => r.approved === VACATION_APPROVED_STATUS.NOT_REVIEWED
    )

    const pendingPlusPayment = requestsList.filter(
        r =>
        r.idTypeDayOff === HOLIDAY_TYPES_IDS.PLUS &&
        r.approved === VACATION_APPROVED_STATUS.APPROVED &&
        !r.plusDaysPayDate
    )

    return (
        <div className="flex align-items-center w-full">
            <div className="flex align-items-center gap-2 flex-grow-1">
                <div style={{ flex: "0 0 48px" }}>
                {pendingApproval.length > 0 && (
                <VacationDayVariantChip
                    dayType={VACATION_DAY_TYPES.POR_APROBAR}
                    quantity={pendingApproval.length}
                    showQuantity
                    variant="long"
                    className="cursor-pointer" 
                    onClick={(event) => {
                    if (pendingApproval.length === 1) {
                        setSelectedVacationRequest(pendingApproval[0])
                        setVisibleRequestModal(true)
                        return
                    }
                    setOverlayRequests(pendingApproval)
                    setActiveTeamMember(data)
                    overlayRef.current?.toggle(event)
                    }}
                    hoverEffect
                />
                )}
                </div>
                <div style={{ flex: "0 0 48px" }}>
                {pendingPlusPayment.length > 0 && (
                <VacationDayVariantChip
                    dayType={VACATION_DAY_TYPES.PLUS_PENDIENTE_PAGO}
                    quantity={pendingPlusPayment.length}
                    showQuantity
                    variant="long"
                    className="cursor-pointer" 
                    onClick={(event) => {
                    if (pendingPlusPayment.length === 1) {
                        setSelectedVacationRequest(pendingPlusPayment[0])
                        setVisibleRequestModal(true)
                        return
                    }
                    setOverlayRequests(pendingPlusPayment)
                    setActiveTeamMember(data)
                    overlayRef.current?.toggle(event)
                    }}
                    hoverEffect
                />
                )}
                </div>
            </div>

            <i
                className="pi pi-ellipsis-v cursor-pointer"
                onClick={(event) => {
                cmRef?.current?.show(event)
                setActiveTeamMember(data)
                }}
            />
            </div>
        )
    }

export default PendingRequestsColumn
